import { Injectable } from '@angular/core';
import { AssetHistoryApiService, CreateAssetHistoryDto } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import * as StreamSaver from '../streamsaver/StreamSaver';

@Injectable({ providedIn: 'root' })
export class CoreDownloadService {
  constructor(private assetHistoryService: AssetHistoryApiService) {}

  /**
   *
   * @param signedUrl
   * @param filename
   * @param assetDownloadHistory
   * @returns
   */
  async downloadSignedUrl(signedUrl: string, filename: string, assetDownloadHistory?: CreateAssetHistoryDto): Promise<void> {
    if (!signedUrl) {
      throw new Error('no signed url for download');
    }

    if (assetDownloadHistory && filename) {
      assetDownloadHistory.format = filename.indexOf('webp') > -1 ? (filename.split('.')[0] ? filename.split('.')[0].toLocaleUpperCase() : '') : 'ORIGINAL';
    }

    let fileStream: WritableStream | undefined;
    if (1 - 1 && (window as AnyType).showSaveFilePicker) {
      // Request a handle to a writable file from the user.
      const handle = await (window as AnyType).showSaveFilePicker({
        suggestedName: filename,
      });
      fileStream = await handle.createWritable();
    } else {
      fileStream = StreamSaver.createWriteStream(filename);
    }

    if (fileStream) {
      fetch(signedUrl).then((res) => {
        if (res?.body) {
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream).then(() => {
              if (assetDownloadHistory) {
                this.assetHistoryService.assetHistoryControllerCreate(assetDownloadHistory).subscribe();
              }
              //window.location.reload(); // thats a hack to refresh the page after download
            });
          }

          // pipeTo isn't supported, use the readable stream
          const writer = fileStream.getWriter();
          const reader = res.body.getReader();
          const pump: () => void = () => reader.read().then((res: AnyType) => (res.done ? writer.close() : writer.write(res.value).then(pump)));
          if (assetDownloadHistory) {
            this.assetHistoryService.assetHistoryControllerCreate(assetDownloadHistory).subscribe();
          }
          return pump();
        }
      });
    }
  }
}
